import { getCurrentAppName, getCurrentContextName } from '../../../supporting';

export const isHSEDesignContext = (): boolean =>
    getCurrentAppName() === 'deziiign' && getCurrentContextName() === 'hsedesign';
import { getCurrentAppName, getCurrentContextName } from '../../../supporting';

export const isHSEDesignContext = (): boolean =>
    getCurrentAppName() === 'deziiign' && getCurrentContextName() === 'hsedesign';
